<template>
  <v-app :style="{ 'background-color': enterpriseColor }">
    <div>
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center

        >
          <v-flex
            xs12
            style="padding-top:40px;"
          >

            <center>
              <v-img
                width="267px"
                :src="'./img/logoDViewConnect.png'"
              />
            </center>
            <center style="color: white; margin-bottom:20px;">
              <div v-html="headerInfo" />
            </center>
            <center>
            <v-card
              style="background-color:#1B2631;"
              :elevation="0"
              max-width="600px"
            >
              <v-card-text>
                <v-form>
                  <v-text-field
                    dark
                    v-model="username"
                    :label="$t('common.email')"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-on:keyup="handleEnter"
                  />

                  <v-text-field
                    dark
                    id="password"
                    v-model="password"
                    :label="$t('common.password')"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-on:keyup="handleEnter"
                  />
                </v-form>
              </v-card-text>
            </v-card>
            <center>
              <v-btn
                outlined
                rounded
                color="white"
                @click="handleLogin"
                style="margin-top: 0px;margin-bottom: 20px;"
              >
                {{ $t('login.login') }}
              </v-btn>
            </center>
            </center>
            <center style="color: white; margin-top:20px;">
              <div v-html="footerInfo" />
            </center>
            <br>
            <center>
              <alert
                v-if="error && error.length > 0"
                style="max-width:567px !important;"
                error
                :text="error"
              />
            </center>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    </div>
  </v-app>
</template>

<script>
  import * as sha1 from 'js-sha1'
  import axios from 'axios'
  // import utils from '@/services/utils.js'
  import Alert from '@/components/Alert' 
  export default {
    components: {
      Alert
    },
    data () {
      return {
        username: null,
        password: null,
        error: null
      }
    },
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      headerInfo () {
        return process.env.VUE_APP_LOGIN_HEADER
      },
      footerInfo () {
        return process.env.VUE_APP_LOGIN_FOOTER
      }
    },
    mounted () {
      localStorage.removeItem('user')
      localStorage.removeItem('jwt')
      // utils.setActiveEnterprise(this)
    },
    methods: {
      handleEnter (e) {
        if (e.keyCode === 13) this.handleLogin()
      },
      handleLogin () {
        this.error = null
        const body = {
          name: this.username,
          password: this.password ? sha1(this.password) : null
        }
        if (!this.username || !this.password || this.username.length === 0 || this.password.length === 0) this.error = 'login.messages.required'
        const that = this
        axios.post(`${process.env.VUE_APP_ENV === 'production' ? 'https' : 'http'}://${process.env.VUE_APP_API_URL}/public/authenticate`, body)
          .then(response => {
            const { user } = response.data
            if (!user) {
              that.error = 'login.messages.userNotFound'
            } else {
              localStorage.setItem('user', user.ID)
              localStorage.setItem('jwt', response.data.token)
              that.$router.push('/player-status-error')
            }
          })
          .catch(function (error) {
            if (error) {
              that.error = 'login.messages.userNotFound'
            }
          })
      }
    }
  }
</script>
